(() => {
  "use strict";
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const root = document.documentElement;
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const finePointer = matchMedia("(hover: hover) and (pointer: fine)").matches;
  root.classList.add("js");
  const CFG = window.TZ_CONFIG || {};
  const PROD = window.TZ_PRODUCT || null;
  const ROOT = (CFG.root || "/").replace(/\/?$/, "/");
  const SHADES = { rose: "Rose Quartz", noir: "Onyx Noir" };
  const SAMPLE_REVIEWS = [
    { name: "Sample \u2014 Am\xE9lie", shade: "Rose", rating: 5, text: "Placeholder review. Replace with a real customer quote about how the curls looked in the morning." },
    { name: "Sample \u2014 Jade", shade: "Noir", rating: 5, text: "Placeholder review. A real quote about comfort while sleeping in the bonnet would go here." },
    { name: "Sample \u2014 In\xE8s", shade: "Rose", rating: 4, text: "Placeholder review. Use a real customer\u2019s words about the unboxing and the keepsake box." },
    { name: "Sample \u2014 Maya", shade: "Noir", rating: 5, text: "Placeholder review. Add a real quote about how long the curls held through the day." }
  ];
  const currentPage = ((_a = ($("[data-page]") || {}).dataset) == null ? void 0 : _a.page) || "other";
  document.body.dataset.route = currentPage;
  const store = {
    get(k, d) {
      try {
        const v = localStorage.getItem("tz_" + k);
        return v ? JSON.parse(v) : d;
      } catch (e) {
        return d;
      }
    },
    set(k, v) {
      try {
        localStorage.setItem("tz_" + k, JSON.stringify(v));
      } catch (e) {
      }
    }
  };
  const session = {
    get(k) {
      try {
        return sessionStorage.getItem("tz_" + k);
      } catch (e) {
        return null;
      }
    },
    set(k, v) {
      try {
        sessionStorage.setItem("tz_" + k, v);
      } catch (e) {
      }
    },
    del(k) {
      try {
        sessionStorage.removeItem("tz_" + k);
      } catch (e) {
      }
    }
  };
  function money(cents) {
    const n = (cents || 0) / 100;
    const fmt = (dec, th, ds) => {
      const [i, d] = n.toFixed(dec).split(".");
      const int = i.replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return d ? int + ds + d : int;
    };
    const f = CFG.moneyFormat || "{{amount}} \u20AC";
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: fmt(2, ",", "."),
      amount_no_decimals: fmt(0, ",", "."),
      amount_with_comma_separator: fmt(2, ".", ","),
      amount_no_decimals_with_comma_separator: fmt(0, ".", ","),
      amount_with_space_separator: fmt(2, " ", ","),
      amount_with_apostrophe_separator: fmt(2, "'", ".")
    })[k] || fmt(2, ",", ".")).replace(/<[^>]*>/g, "");
  }
  const setText = (sel, t) => {
    const el = $(sel);
    if (el) el.textContent = t;
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
  let toastTimer;
  function toast(msg) {
    setText("#toastText", msg);
    const t = $("#toast");
    if (!t) return;
    t.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("is-visible"), 3200);
  }
  let lenis = null;
  if (window.Lenis && !reduced) {
    lenis = new Lenis({ duration: 1.25, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }
  function scrollToY(y, immediate) {
    if (lenis) lenis.scrollTo(y, { immediate: !!immediate, duration: 1.4 });
    else window.scrollTo({ top: y, behavior: immediate || reduced ? "auto" : "smooth" });
  }
  function scrollToEl(el, immediate) {
    const off = el.id === "home" ? 0 : 80;
    scrollToY(el.getBoundingClientRect().top + window.scrollY - off, immediate);
  }
  function lockScroll(on) {
    document.body.classList.toggle("is-locked", on);
    if (lenis) on ? lenis.stop() : lenis.start();
  }
  const mark = $("#preloaderMark");
  if (mark) {
    mark.innerHTML = mark.textContent.split("").map((c, i) => {
      const d = "animation-delay:".concat(i * 0.05, "s");
      if (i === 0) return '<span class="logo__t" style="'.concat(d, '">').concat(c, "</span>");
      if (c === "z") return '<em style="'.concat(d, '">').concat(c, "</em>");
      return '<span style="'.concat(d, '">').concat(c, "</span>");
    }).join("");
  }
  let loaded = false;
  function finishLoad() {
    if (loaded) return;
    loaded = true;
    const p = $("#preloader");
    document.body.classList.add("is-loaded");
    if (!p) return;
    p.classList.add("is-done");
    setTimeout(() => p.remove(), 1200);
  }
  const fromTransition = session.get("curtain") === "1";
  if (reduced || fromTransition) {
    const p = $("#preloader");
    if (p) p.remove();
    finishLoad();
  } else {
    session.set("seen", "1");
    const minTime = new Promise((r) => setTimeout(r, 1500));
    const ready = new Promise((r) => {
      if (document.readyState === "complete") r();
      else addEventListener("load", r);
      setTimeout(r, 3500);
    });
    Promise.all([minTime, ready]).then(finishLoad);
  }
  const curtain = $("#curtain");
  function liftCurtain() {
    if (!curtain) return;
    session.del("curtain");
    curtain.classList.add("is-cover");
    void curtain.offsetWidth;
    requestAnimationFrame(() => {
      curtain.classList.remove("is-cover");
      curtain.classList.add("is-out");
      setTimeout(() => curtain.classList.remove("is-out"), 850);
    });
  }
  if (fromTransition) liftCurtain();
  addEventListener("pageshow", (e) => {
    if (e.persisted && curtain) {
      curtain.classList.remove("is-in", "is-cover");
      session.del("curtain");
    }
  });
  document.addEventListener("click", (e) => {
    const a = e.target.closest("a[href]");
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target === "_blank" || a.hasAttribute("download")) return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.hash) {
      const el = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (el) {
        e.preventDefault();
        closeMenu();
        closeCart();
        scrollToEl(el);
        history.replaceState(null, "", url.hash);
      }
      return;
    }
    if (reduced || !curtain || /\/(checkout|account)/.test(url.pathname)) return;
    e.preventDefault();
    closeMenu();
    closeCart();
    curtain.classList.remove("is-out");
    void curtain.offsetWidth;
    curtain.classList.add("is-in");
    session.set("curtain", "1");
    setTimeout(() => {
      location.href = url.href;
    }, 700);
  });
  if (location.hash.length > 1) {
    const el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (el) setTimeout(() => scrollToEl(el, true), 60);
  }
  if (finePointer && !reduced && $("#cursor")) {
    const cur = $("#cursor"), dot = $(".cursor__dot", cur), ring = $(".cursor__ring", cur), lab = $(".cursor__label", cur);
    let mx = innerWidth / 2, my = innerHeight / 2, rx = mx, ry = my;
    addEventListener("mousemove", (e) => {
      mx = e.clientX;
      my = e.clientY;
      dot.style.transform = "translate(".concat(mx, "px, ").concat(my, "px) translate(-50%,-50%)");
    }, { passive: true });
    (function loop() {
      rx += (mx - rx) * 0.16;
      ry += (my - ry) * 0.16;
      const tr = "translate(".concat(rx, "px, ").concat(ry, "px) translate(-50%,-50%)");
      ring.style.transform = tr;
      lab.style.transform = tr;
      requestAnimationFrame(loop);
    })();
    document.addEventListener("mouseover", (e) => {
      const labelEl = e.target.closest("[data-cursor-label]");
      const hoverEl = e.target.closest("a, button, [data-cursor], input, select, textarea, label");
      cur.classList.toggle("has-label", !!labelEl);
      lab.textContent = labelEl ? labelEl.dataset.cursorLabel : "";
      cur.classList.toggle("is-hover", !!hoverEl && !labelEl);
    });
    document.addEventListener("mouseleave", () => {
      cur.style.opacity = 0;
    });
    document.addEventListener("mouseenter", () => {
      cur.style.opacity = 1;
    });
    $$(".btn, .carousel-nav button, .socials a").forEach((b) => {
      b.addEventListener("mousemove", (e) => {
        const r = b.getBoundingClientRect();
        b.style.transform = "translate(".concat((e.clientX - r.left - r.width / 2) * 0.18, "px, ").concat((e.clientY - r.top - r.height / 2) * 0.25, "px)");
      });
      b.addEventListener("mouseleave", () => {
        b.style.transform = "";
      });
    });
  }
  let shade = store.get("shade", "rose");
  if (!SHADES[shade]) shade = "rose";
  function applyShade(s) {
    shade = s;
    updateBuyLabels();
    store.set("shade", s);
    document.dispatchEvent(new CustomEvent("tz:shade", { detail: s }));
  }
  document.addEventListener("click", (e) => {
    const g = e.target.closest("[data-goto-shade]");
    if (!g) return;
    store.set("shade", g.dataset.gotoShade);
    if (currentPage === "product") {
      applyShade(g.dataset.gotoShade);
      scrollToY(0);
    } else location.href = CFG.productUrl || ROOT;
  });
  const header = $("#header");
  let lastY = 0;
  function updateHeader() {
    if (!header) return;
    const y = window.scrollY;
    const hero = $("#home");
    const overHero = currentPage === "home" && hero && y < hero.offsetHeight - 90;
    header.classList.toggle("is-over-hero", !!overHero && !document.body.classList.contains("menu-open"));
    header.classList.toggle("is-hidden", y > 300 && y > lastY + 4 && !document.body.classList.contains("menu-open"));
    if (y < lastY - 4 || y < 300) header.classList.remove("is-hidden");
    lastY = y;
  }
  const navUrl = location.pathname === "/" ? null : location.pathname;
  $$(".nav a").forEach((a) => {
    if (navUrl && new URL(a.href, location.href).pathname === navUrl) a.classList.add("is-active");
  });
  function closeMenu() {
    if (!document.body.classList.contains("menu-open")) return;
    document.body.classList.remove("menu-open");
    $("#menuToggle").setAttribute("aria-expanded", "false");
    $("#menuToggle").setAttribute("aria-label", "Open menu");
    $("#mobileMenu").setAttribute("aria-hidden", "true");
    if (!$("#drawer").classList.contains("is-open")) lockScroll(false);
  }
  (_b = $("#menuToggle")) == null ? void 0 : _b.addEventListener("click", () => {
    if (document.body.classList.contains("menu-open")) return closeMenu();
    document.body.classList.add("menu-open");
    $("#menuToggle").setAttribute("aria-expanded", "true");
    $("#menuToggle").setAttribute("aria-label", "Close menu");
    $("#mobileMenu").setAttribute("aria-hidden", "false");
    lockScroll(true);
    updateHeader();
  });
  const heroVideo = $("#heroVideo");
  if (heroVideo) heroVideo.play().catch(() => {
  });
  $$("[data-lazy-video]").forEach((v) => {
    new IntersectionObserver(([en]) => {
      if (en.isIntersecting) {
        if (v.preload !== "auto") v.preload = "auto";
        v.play().catch(() => {
        });
      } else v.pause();
    }, { rootMargin: "200px 0px" }).observe(v);
  });
  const mf = $("#manifestoText");
  let words = [];
  if (mf) {
    (function split(node) {
      Array.from(node.childNodes).forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((w) => {
            if (!w) return;
            if (/^\s+$/.test(w)) frag.append(w);
            else {
              const s = document.createElement("span");
              s.className = "w";
              s.textContent = w;
              frag.append(s);
            }
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) split(n);
      });
    })(mf);
    words = $$(".w", mf);
  }
  function fillWords() {
    if (!mf) return;
    const r = mf.getBoundingClientRect();
    const p = Math.min(1, Math.max(0, (innerHeight * 0.85 - r.top) / (r.height + innerHeight * 0.35)));
    const n = Math.round(p * words.length);
    words.forEach((w, i) => w.classList.toggle("on", i < n));
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (en.isIntersecting) {
        en.target.classList.add("is-in");
        io.unobserve(en.target);
      }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
  function refreshReveals() {
    $$(".reveal:not(.is-in), .reveal-img:not(.is-in)").forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < innerHeight && r.bottom > 0) requestAnimationFrame(() => el.classList.add("is-in"));
      else io.observe(el);
    });
  }
  const boxVideo = $("#boxVideo");
  if (boxVideo) {
    if (reduced) boxVideo.controls = true;
    else new IntersectionObserver(([en]) => {
      if (en.isIntersecting) boxVideo.play().catch(() => {
      });
      else boxVideo.pause();
    }, { threshold: 0.5 }).observe(boxVideo);
  }
  const stepIO = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const i = en.target.dataset.step;
      $$(".step").forEach((s) => s.classList.toggle("is-active", s.dataset.step === i));
      $$(".ritual__visual img[data-step]").forEach((im) => im.classList.toggle("is-active", im.dataset.step === i));
    });
  }, { rootMargin: "-45% 0px -45% 0px" });
  $$(".step").forEach((s) => stepIO.observe(s));
  const statements = $$("[data-marquee]");
  const parallax = $$("[data-parallax]");
  const heroMedia = $(".hero__media");
  function onScroll() {
    updateHeader();
    fillWords();
    if (currentPage === "product") updateSticky();
    if (reduced) return;
    statements.forEach((el) => {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      const p = (innerHeight - r.top) / (innerHeight + r.height);
      const dir = +el.dataset.marquee;
      el.style.transform = "translateX(".concat(dir < 0 ? -p * 30 : -30 + p * 30, "%)");
    });
    parallax.forEach((el) => {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      el.style.transform = "translateY(".concat(-(r.top + r.height / 2 - innerHeight / 2) * +el.dataset.parallax - r.height * 0.07, "px)");
    });
    if (heroMedia && window.scrollY < innerHeight) heroMedia.style.transform = "translateY(".concat(window.scrollY * 0.35, "px)");
  }
  if (lenis) lenis.on("scroll", onScroll);
  addEventListener("scroll", onScroll, { passive: true });
  addEventListener("resize", onScroll);
  document.addEventListener("click", (e) => {
    const b = e.target.closest(".acc__btn");
    if (!b) return;
    const open = b.getAttribute("aria-expanded") === "true";
    b.setAttribute("aria-expanded", !open);
    setTimeout(() => lenis && lenis.resize(), 650);
  });
  const stars = (n) => "\u2605\u2605\u2605\u2605\u2605".slice(0, n) + "\u2606\u2606\u2606\u2606\u2606".slice(0, 5 - n);
  const track = $("#reviewsTrack");
  if (track) {
    track.innerHTML = SAMPLE_REVIEWS.map((r) => '<article class="review"><div class="stars" aria-label="'.concat(r.rating, ' out of 5">').concat(stars(r.rating), "</div>\n      <blockquote>").concat(esc(r.text), "</blockquote>\n      <footer><span>").concat(esc(r.name), " \xB7 ").concat(esc(r.shade), '</span><span class="chip">Sample</span></footer></article>')).join("");
    const step = () => track.firstElementChild ? track.firstElementChild.offsetWidth + 24 : 400;
    (_c = $("#revPrev")) == null ? void 0 : _c.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    (_d = $("#revNext")) == null ? void 0 : _d.addEventListener("click", () => {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) track.scrollTo({ left: 0, behavior: "smooth" });
      else track.scrollBy({ left: step(), behavior: "smooth" });
    });
  }
  const emailOk = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());
  const newsForm = $("#newsForm"), newsMsg = $("#newsMsg");
  if (newsForm && newsMsg) {
    if ($("[data-news-ok]", newsForm)) {
      newsMsg.textContent = "Welcome to the club. Check your inbox for your welcome code.";
      newsMsg.className = "form-msg";
    }
    const err = $("[data-news-err]", newsForm);
    if (err) {
      newsMsg.textContent = err.textContent.trim() || "Check your email address and try again.";
      newsMsg.className = "form-msg err";
    }
    newsForm.addEventListener("submit", (e) => {
      const v = $("#newsEmail").value;
      if (!emailOk(v)) {
        e.preventDefault();
        newsMsg.textContent = "Enter a valid email address, like name@example.com.";
        newsMsg.className = "form-msg err";
      }
    });
  }
  const reviewForm = $("#reviewForm");
  if (reviewForm) {
    const setErr = (input, msg) => {
      const f = input.closest(".field");
      f.classList.toggle("has-error", !!msg);
      const e = $(".err-text", f);
      if (e) e.textContent = msg || "";
      return !msg;
    };
    let picked = 0;
    $$("#starInput button").forEach((b) => b.addEventListener("click", () => {
      picked = +b.dataset.v;
      $("#revRating").value = picked + " / 5";
      $$("#starInput button").forEach((x) => {
        x.classList.toggle("on", +x.dataset.v <= picked);
        x.setAttribute("aria-checked", +x.dataset.v === picked);
      });
      $('[data-err-for="rating"]').textContent = "";
    }));
    reviewForm.addEventListener("submit", (e) => {
      $("#revShadeField").value = shade === "noir" ? "Noir" : "Rose";
      const name = $("#revName"), mail = $("#revEmail"), text = $("#revText");
      let ok = true;
      if (!picked) {
        $('[data-err-for="rating"]').textContent = "Choose a rating from 1 to 5 stars.";
        ok = false;
      }
      ok = setErr(name, name.value.trim() ? "" : "Add your name.") && ok;
      ok = setErr(mail, emailOk(mail.value) ? "" : "Enter a valid email, like name@example.com.") && ok;
      ok = setErr(text, text.value.trim().length >= 10 ? "" : "Write at least 10 characters.") && ok;
      if (!ok) e.preventDefault();
    });
    if ($("[data-review-sent]", reviewForm) || /contact_posted|form_type=contact/.test(location.search)) {
      setTimeout(() => scrollToEl($("#pdpReviews"), true), 80);
    }
  }
  (_e = $("#copyMail")) == null ? void 0 : _e.addEventListener("click", () => {
    const el = $("#mailAddr");
    const sel = () => {
      const r = document.createRange();
      r.selectNodeContents(el);
      const s = getSelection();
      s.removeAllRanges();
      s.addRange(r);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(el.textContent).then(() => toast("Email copied")).catch(() => {
      sel();
      toast("Press Ctrl+C to copy");
    });
    else {
      sel();
      toast("Press Ctrl+C to copy");
    }
  });
  let wished = store.get("wish", false);
  function renderWish() {
    const u = $("#wishHeader use");
    if (u) u.setAttribute("fill", wished ? "currentColor" : "none");
  }
  (_f = $("#wishHeader")) == null ? void 0 : _f.addEventListener("click", () => {
    if (currentPage === "product") {
      wished = !wished;
      store.set("wish", wished);
      renderWish();
      toast(wished ? "Saved to your wishlist" : "Removed from your wishlist");
    } else if (wished) {
      location.href = CFG.productUrl || ROOT;
    } else toast("Your wishlist is empty. Tap the heart on the kit page to save it.");
  });
  function updateBuyLabels() {
    if (!PROD) return;
    setText("#stickyShade", "".concat(SHADES[shade], " \xB7 ").concat(money(PROD.price)));
    const stickyImg = $("#stickyBuy img");
    if (stickyImg) stickyImg.src = "".concat(CFG.assets, "tz-cart-kit-").concat(shade, ".webp");
  }
  (_g = $("#stickyAdd")) == null ? void 0 : _g.addEventListener("click", () => {
    addToCart(shade, false, 1);
  });
  const sticky = $("#stickyBuy");
  function updateSticky() {
    const anchor = $("#vhAdd");
    if (!anchor || !sticky) return;
    const show = anchor.getBoundingClientRect().bottom < 0;
    sticky.classList.toggle("is-visible", show);
    sticky.setAttribute("aria-hidden", !show);
    $("#stickyAdd").tabIndex = show ? 0 : -1;
  }
  let cart = CFG.cart || { items: [], item_count: 0, total_price: 0 };
  const api = (path, body) => fetch(ROOT + path, {
    method: body ? "POST" : "GET",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: body ? JSON.stringify(body) : void 0
  }).then(async (r) => {
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || "Something went wrong. Try again.");
    return data;
  });
  const shadeOf = (item) => /noir|black|onyx/i.test(item.variant_title || "") ? "noir" : "rose";
  const isKit = (item) => CFG.kitId && item.product_id === CFG.kitId || PROD && item.product_id === PROD.id;
  async function refreshCart() {
    try {
      cart = await api("cart.js");
    } catch (e) {
    }
    renderCart();
  }
  async function addToCart(s, gift, n = 1) {
    const v = PROD && PROD.variants && PROD.variants[s];
    if (!v) {
      toast("The ".concat(SHADES[s], " kit isn't set up in the store yet."));
      return false;
    }
    if (!v.available) {
      toast("The ".concat(SHADES[s], " kit is sold out for now."));
      return false;
    }
    openCart();
    try {
      await api("cart/add.js", { items: [{ id: v.id, quantity: n }] });
      await refreshCart();
      const c = $("#cartCount");
      c.classList.remove("bump");
      void c.offsetWidth;
      c.classList.add("bump");
      toast("".concat(SHADES[s], " kit added to your bag"));
      return true;
    } catch (err) {
      toast(err.message);
      return false;
    }
  }
  async function changeLine(key, quantity) {
    try {
      cart = await api("cart/change.js", { id: key, quantity });
    } catch (err) {
      toast(err.message);
    }
    renderCart();
  }
  function lineHTML(i) {
    const s = shadeOf(i);
    const img = isKit(i) ? "".concat(CFG.assets, "tz-cart-kit-").concat(s, ".webp") : i.image || "";
    const meta = i.variant_title ? esc(i.variant_title) : "";
    return '<div class="line" data-key="'.concat(esc(i.key), '">\n      ').concat(img ? '<img src="'.concat(img, '" alt="').concat(esc(i.product_title), '" class="kit-thumb">') : "<span></span>", '\n      <div>\n        <div class="line__top"><div><a class="line__name" href="').concat(esc(i.url), '">').concat(esc(i.product_title), '</a><div class="line__meta">').concat(meta, "</div></div><span>").concat(money(i.final_line_price), '</span></div>\n        <div class="line__bottom">\n          <div class="qty"><button data-line-qty="-1" aria-label="Decrease">\u2212</button><span>').concat(i.quantity, '</span><button data-line-qty="1" aria-label="Increase">+</button></div>\n          <button class="remove" data-remove>Remove</button>\n        </div>\n      </div></div>');
  }
  function renderCart() {
    const count = cart.item_count || 0;
    const total = cart.total_price || 0;
    const cc = $("#cartCount");
    if (cc) {
      cc.textContent = count;
      cc.classList.toggle("is-visible", count > 0);
    }
    setText("#drawerCount", count ? "(".concat(count, ")") : "");
    setText("#drawerSubtotal", money(total));
    const free = CFG.freeShipping || 6e3;
    const left = free - total;
    const shipText = $("#shipText");
    if (shipText) shipText.innerHTML = !count ? "Free shipping on orders over ".concat(esc(money(free))) : left > 0 ? "You're <b>".concat(esc(money(left)), "</b> away from free shipping") : "You unlocked <b>free shipping</b>";
    const fill = $("#shipFill");
    if (fill) fill.style.transform = "scaleX(".concat(Math.min(1, total / free), ")");
    const foot = $("#drawerFoot");
    if (foot) foot.hidden = !count;
    const body = $("#drawerBody");
    if (body) body.innerHTML = count ? cart.items.map(lineHTML).join("") : '<div class="empty-state"><p class="h3">Your bag is empty.</p><p class="small">Your next good-hair morning starts here.</p><a href="'.concat(esc(CFG.productUrl || ROOT), '" class="btn">Shop the kit</a></div>');
  }
  document.addEventListener("click", (e) => {
    const line = e.target.closest("#drawerBody [data-key]");
    if (!line) return;
    const item = cart.items.find((i) => i.key === line.dataset.key);
    if (!item) return;
    const q = e.target.closest("[data-line-qty]");
    if (q) changeLine(item.key, Math.max(0, item.quantity + +q.dataset.lineQty));
    if (e.target.closest("[data-remove]")) {
      changeLine(item.key, 0);
      toast("Removed from your bag");
    }
  });
  const drawer = $("#drawer"), overlay = $("#overlay");
  (_h = $("#drawerBody")) == null ? void 0 : _h.setAttribute("data-lenis-prevent", "");
  function openCart() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    overlay.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    lockScroll(true);
    setTimeout(() => $("#cartClose").focus(), 100);
  }
  function closeCart() {
    if (!drawer || !drawer.classList.contains("is-open")) return;
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    lockScroll(false);
  }
  (_i = $("#cartOpen")) == null ? void 0 : _i.addEventListener("click", () => {
    if (currentPage === "cart") return;
    openCart();
  });
  $$("[data-open-cart]").forEach((b) => b.addEventListener("click", openCart));
  (_j = $("#cartClose")) == null ? void 0 : _j.addEventListener("click", closeCart);
  (_k = $("#keepShopping")) == null ? void 0 : _k.addEventListener("click", closeCart);
  overlay == null ? void 0 : overlay.addEventListener("click", closeCart);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeCart();
      closeMenu();
    }
  });
  (_l = $("#toTop")) == null ? void 0 : _l.addEventListener("click", () => scrollToY(0));
  window.TZ = { applyShade, addToCart, openCart, getShade: () => shade, currentPage: () => currentPage };
  applyShade(shade);
  renderWish();
  renderCart();
  refreshReveals();
  onScroll();
  addEventListener("pageshow", (e) => {
    if (e.persisted) refreshCart();
  });
})();
